import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getHourlyCharges } from "../store/slices/carrentalpackage";
import Footer from "./Footer";
import Navbarsticky from "./NavbarSticky";
import { Row, Col, Container, Form } from "react-bootstrap";

const HourlyBooking = () => {
  const query = new URLSearchParams(useLocation().search);

  const duration = query.get("duration");
  const date = query.get("date");
  const time = query.get("time");

  const dispatch = useDispatch();

  // Safe selector
  const { hourlyCharges = {}, loading = false } = useSelector(
    (state) => state.carrental || {},
  );

  const [vehicleList, setVehicleList] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  // ------------------ FIXED API FETCH ------------------
  useEffect(() => {
    if (!duration) return;

    dispatch(getHourlyCharges({ duration }))
      .unwrap()
      .then((data) => {
        setVehicleList(data?.hourlyCharges?.carData || []);
      })
      .catch((err) => {
        console.error("Hourly Charges Fetch Error:", err);
        setVehicleList([]);
      });
  }, [duration, dispatch]);

  const vehicleData = vehicleList || [];

  return (
    <>
      {/* Navbar */}
      <Navbarsticky />
      <div className="hourlybooking-container"></div>
      <div className="container mt-5 mb-5">
        {/* search bar */}
        <div
          className="pd-form d-flex flex-wrap align-item-center justify-content-around my-4 mx-2 px-2"
          style={{ padding: "10px" }}
        >
          <Form.Group className="mb-1 mx-1">
            <Form.Label className="pd-filter-label">Rentel Booking</Form.Label>
            <div className="input-with-icon-pd">
              <input
                type="text"
                className="pd-filter-input"
                defaultValue="Hourly Rental Booking"
              />
              <i className="bi bi-clock-history"></i>
            </div>
          </Form.Group>

          <Form.Group className="mb-3 mx-1">
            <Form.Label className="pd-filter-label"> Duration </Form.Label>
            <div className="input-with-icon-pd">
              <input
                type="text"
                className="pd-filter-input"
                defaultValue={duration}
              />
              <i className="bi bi-hourglass-split"></i>
            </div>
          </Form.Group>

          <Form.Group className="mb-1 mx-1">
            <Form.Label className="pd-filter-label">Date</Form.Label>
            <div className="input-with-icon-pd">
              <input
                type="date"
                className="pd-filter-input"
                defaultValue={date}
              />
            </div>
          </Form.Group>

          <Form.Group className="mb-1">
            <Form.Label className="pd-filter-label">Transfer</Form.Label>
            <div className="input-with-icon-pd">
              <input
                type="time"
                className="pd-filter-input"
                defaultValue={time}
              />
            </div>
          </Form.Group>

          <Link to="/carrental">
            <button
              className="pickupdrop-search-btn"
              style={{ maxHeight: "50px", margin: "5px" }}
            >
              Modify Search&nbsp;<i className="bi bi-search"></i>
            </button>
          </Link>
        </div>

        <div className="container my-5">
          <Container className="column main-area">
            <Row>
              {/* vehicle list */}
              <Col lg={12} md={12}>
                <div className="results-header d-flex align-items-center justify-content-between">
                  <div>
                    {loading && <p>Loading vehicle list...</p>}

                    {!loading && vehicleData.length === 0 && (
                      <p className="text-danger">
                        No vehicles available for this duration.
                      </p>
                    )}
                  </div>
                </div>

                {/* vehicle grid */}
                <Row xs={1} sm={2} md={3} lg={3} className="g-4 mt-2">
                  {vehicleData.flatMap((group) =>
                    group.vehicle.map((item) => {
                      const car = item.vehicle;
                      const price = item.price;

                      return (
                        <Col
                          key={car._id}
                          lg={4}
                          md={4}
                          sm={6}
                          xs={12}
                          className="mb-4"
                        >
                          <div
                            className={`vehicle-card ${
                              selectedVehicle?._id === car._id
                                ? "vehicle-selected"
                                : ""
                            }`}
                            onClick={() =>
                              setSelectedVehicle({
                                _id: car._id,
                                name: car.carName,
                                image: car.carImage,
                                price,
                              })
                            }
                          >
                            {/* Image */}
                            <div className="vehicle-img-container">
                              <img
                                src={car.carImage}
                                alt={car.carName}
                                className="vehicle-img"
                              />
                              <span
                                className={`vehicle-badge ${
                                  car.carType?.toLowerCase() === "luxury car"
                                    ? "badge-luxury"
                                    : "badge-normal"
                                }`}
                              >
                                {car.carType}
                              </span>
                            </div>

                            <div className="vehicle-body p-3">
                              <h5 className="vehicle-title">{car.carName}</h5>

                              <div className="vehicle-specs">
                                <span>
                                  <i className="bi bi-snow"></i> AC
                                </span>
                                <span>
                                  <i className="bi bi-people-fill"></i>{" "}
                                  {car.minMember}–{car.maxMember} seats
                                </span>
                              </div>

                              <div className="vehicle-info">
                                <span>✔ {group.distance}</span>
                                <span>✔ {group.duration}</span>
                              </div>

                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <h5 className="vehicle-price">₹ {price}</h5>
                                <span className="vehicle-tax">
                                  + ₹{(price * 5) / 100} taxes
                                </span>
                              </div>

                              <button className="vehicle-btn mt-3 w-100">
                                Book Now
                              </button>
                            </div>
                          </div>
                        </Col>
                      );
                    }),
                  )}
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default HourlyBooking;
